export default __webpack_public_path__ + "logo.cab23003c21cc38b49f17b4688f5cca0.png";